export enum DBDocSchemaFields {
  id = 'id',
  createTime = 'createTime',
  lastUploadTime = 'lastUploadTime',

  createdByUserId = 'createdByUserId',
  lastModifiedByUserId = 'lastModifiedByUserId',
}
